module.exports = __webpack_public_path__ + "assets/2deb071293836bdcd8e120b616bbdef0.mp3";